export default __webpack_public_path__ + "static/media/img_9_thumb.5873d333.JPG";